import { axios, Response } from '../index'

const deleteChecklist = (
  companyId: string,
  personaType: string,
  personaId: string,
  checklistId: string,
  taskId: string
): Response<null> => {
  return axios.delete(`/v1/tasks/${taskId}/checklists/${checklistId}`, {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default deleteChecklist
